import { AxiosRequestConfig } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { ApiError } from '@types';
import { config } from '../../config';
export const fetchPaperlessAsync = createAsyncAction(
    [
        'enroll/FETCH_PAPERLESS_REQUEST',
        (accountNumber: string) => {
            return {
                url: `${config.env('paperlessUrl')}?loanNumber=${accountNumber}`,
                headers: {
                    'x-api-key': `${config.env('xApiKey')}`,
                    'Content-Type': 'application/json'
                },
                data: { statementEnrollmentIndicator: true },
                method: 'put'
            } as AxiosRequestConfig;
        }
    ],
    ['enroll/FETCH_PAPERLESS_SUCCESS', (response: any) => response],
    ['enroll/FETCH_PAPERLESS_FAILURE', (error: ApiError) => error],
    'enroll/FETCH_PAPERLESS_CANCEL'
)();

export const shownPaperlessSuccess = createAction('SET_PAPERLESS_SHOWN_STATUS', (shownPaperlessSnack: boolean) => shownPaperlessSnack)();
